import { getImageUrl } from '@chewy/chat-library-common';
const DEFAULT_PET_AVATAR_BASE_URL = 'https://static.chewy.com/lib/pet-profile/1.0.0/img/avatars';

const DEFAULT_PET_AVATAR_FILES: Record<string, string> = {
  bird: 'avatar_bird_01.png',
  cat: 'avatar_cat_01.png',
  dog: 'avatar_dog_01.png',
  'farm animal': 'default_farm_animal.png',
  fish: 'avatar_fish_01.png',
  horse: 'avatar_horse_01.png',
  reptile: 'avatar_reptile_01.png',
  'small pet': 'default_small_pet.png',
};

const normalizeBreedType = (breedType?: string) => (
  breedType?.trim().toLowerCase().replace(/[-_]+/g, ' ').replace(/\s+/g, ' ') ?? ''
);

export const getDefaultPetAvatarUrl = (breedType?: string) => {
  const avatarFile = DEFAULT_PET_AVATAR_FILES[normalizeBreedType(breedType)];

  return `${DEFAULT_PET_AVATAR_BASE_URL}/${avatarFile}`;
};

export const getPetImageUrl = (imageUrl?: string, breedType?: string, imageSize = 250) => (
  getImageUrl(imageUrl, imageSize) || getDefaultPetAvatarUrl(breedType)
);
